/* eslint-disable camelcase */
import { action, observable } from 'mobx';
import { i18nLocalStorageKey } from 'src/i18n';
import { SettingsStore } from 'src/stores/SettingsStore/SettingsStore';

export class AuthStoreClass {
    @observable authenticated = false;
    @observable actionIdentifier?: string;
    @observable token?: string;

    @action async authenticate() {
        try {
            // Ensure Keycloak is initialized
            SettingsStore.setupKeycloak();
            const { keycloak } = SettingsStore;

            if (!keycloak) {
                console.error('Keycloak instance is not available.');
                this.authenticated = false;

                return;
            }
            const i18nLocale =
                localStorage.getItem(i18nLocalStorageKey) || undefined;
            // Initialize Keycloak only if not already authenticated
            const authenticated =
                (await keycloak.init({
                    onLoad: 'check-sso',
                    silentCheckSsoRedirectUri: `${window.location.origin}/silent-check-sso.html`,
                    pkceMethod: 'S256',
                    scope: 'openid email profile phone',
                    locale: i18nLocale,
                })) || false;

            if (!authenticated) {
                console.warn('User not authenticated, redirecting to login...');
                await keycloak.login({
                    scope: 'openid email profile phone',
                    locale: i18nLocale,
                });
            }

            // Ensure token is fresh
            await SettingsStore.updateTokenIfNeed();
            this.authenticated = authenticated;
            this.token = keycloak.token;
        } catch (error) {
            console.error('Authentication failed:', error);
            this.authenticated = false;
        }
    }

    @action async logout(redirectUrl?: string) {
        const { keycloak } = SettingsStore;
        if (!keycloak) {
            console.error('Keycloak instance is not available.');

            return;
        }

        await keycloak.logout({
            redirectUri:
                redirectUrl ||
                `${window.location.protocol}//${window.location.host}`,
        });

        this.authenticated = false;
        this.token = undefined;
    }
}

export const AuthStore = new AuthStoreClass();
